module.exports = __webpack_public_path__ + "assets/GoldLambda2x.ee0f4bb397649b704809e394dfa05065.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs2x-gold/GoldLambda2x.png
// module id = 813
// module chunks = 0